export default "/img/HN.d9aeb344ec6014f2809015f58280e663.png";